// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const HistoryIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M12.18 1.84c1.12 0 2 .08 3.08.4 2.6.8 4.8 2.6 6.08 5 1.24 2.32 1.5 5.25.72 7.75-.82 2.59-2.61 4.75-5 6.02-4.14 2.17-9.46 1.2-12.46-2.4-.45-.54-1.06-1.12-.8-1.9q.17-.52.66-.77c.34-.17.82-.15 1.15.05.38.24.68.7.98 1.05.88 1 2 1.75 3.26 2.18 1.56.52 3.48.52 5.03-.03.35-.12.76-.33 1.1-.5q1.6-.87 2.64-2.36c1.16-1.69 1.6-3.76 1.22-5.76-.39-2.02-1.58-3.8-3.3-4.95-3.17-2.14-7.56-1.48-10 1.4-.32.37-.58.77-.86 1.17h.53c.53.04 1.43-.12 1.85.29.87.84.37 2.23-.9 2.23-1.52 0-3.04.04-4.55-.02-.71-.08-1.1-.6-1.1-1.3V5.25c0-.34-.01-.63.18-.93.44-.7 1.39-.82 1.98-.23.48.47.36 1.37.36 2l.37-.5c1.57-1.93 3.86-3.28 6.33-3.66.47-.07.98-.08 1.45-.1"
        opacity=".5"
      />
      <path d="M12.33 6.89c.4.05.9.34.93.78.07.92.01 1.86.03 2.78v1.15c.31.27.74.75 1.06 1.06q.73.71 1.45 1.45c.65.7.38 1.48-.55 1.7-.2 0-.52-.1-.67-.25-.98-.9-1.93-1.89-2.87-2.84-.43-.44-.34-.98-.34-1.54V8.44c0-.4-.06-.83.22-1.17.2-.25.44-.34.74-.38" />
    </g>
  </SvgIcon>
);

export default HistoryIcon;
